import { render, staticRenderFns } from "./TareaManualComponent.vue?vue&type=template&id=087b8b47&"
import script from "./TareaManualComponent.vue?vue&type=script&lang=js&"
export * from "./TareaManualComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports